<div class="club-header-dropdown">
  <a class="club-header-button">
    <ng-content select="[dropButton]"></ng-content>
  </a>
  <div class="club-header-dropdown-content  slideInUp  animated tw-shadow-md">
    <ng-content select="[dropContent]"></ng-content>
  </div>
</div>
